import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

import areaIcon from '../Images/area-icon.png'
import tileIcon from '../Images/tile-icon.png'
import surfaceIcon from '../Images/surface-icon.png'
import appIcon from '../Images/application-icon.png'
import bagIcon from '../Images/bag-icon.png'
import bulbIcon from '../Images/bulb-icon.png'
import sizeIcon from '../Images/size-icon.png'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CalculatorSection = () => {

  // Container stagger
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.15,
      },
    },
  };

  // Fade only
  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const [result, setResult] = useState(null);
  const [lastInputs, setLastInputs] = useState(null);
  const [showModal, setShowModal] = useState(false);
const [userData, setUserData] = useState({
  name: "",
  email: ""
});
const [pendingResult, setPendingResult] = useState(null);
const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
  area: "",
  tileSize: "",
  surface: "",
  application: "",
  bedSize: ""
});

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: value
  }));
};

const calculateAdhesive = ({ area, tileSize, surface, application, bedSize }) => {
  if (!area || area <= 0) {
    return { error: "Please enter valid area" };
  }

  // 🔹 Base consumption (kg/sq ft)
  const baseRates = {
    small: 0.35,
    medium: 0.45,
    large: 0.60
  };

  // 🔹 Surface factor
  const surfaceFactor = {
    floor: 1.0,
    wall: 0.9
  };

  // 🔹 Application factor
  const appFactor = {
    interior: 1.0,
    exterior: 1.15
  };

  const base = baseRates[tileSize];
  const surfaceMul = surfaceFactor[surface];
  const appMul = appFactor[application];
  const bedFactor = bedSize / 4;

  // 🧠 Final consumption per sq ft
  const finalRate = base * surfaceMul * appMul * bedFactor;

  // 🧮 Total kg
  let totalKg = area * finalRate;

  // 📦 Bags (25kg each)
  let bags = Math.ceil(totalKg / 25);

  // Edge case → minimum 1 bag
  if (bags < 1) bags = 1;

  // 🎯 Product recommendation
  let product = "Grip Bond";

  if (application === "exterior" || tileSize === "large") {
    product = "Ultra Bond";
  } else if (tileSize === "medium") {
    product = "Pro Bond";
  }

  return {
    totalKg: totalKg.toFixed(1),
    bags,
    product,
    finalRate: finalRate.toFixed(2)
  };
};


const handleCalculate = () => {

  if (!formData.area) {
    toast.error("Please enter area");
    return;
  }

  if (!formData.tileSize) {
    toast.error("Please select tile size");
    return;
  }

  if (!formData.surface) {
    toast.error("Please select surface type");
    return;
  }

  if (!formData.application) {
    toast.error("Please select application type");
    return;
  }

  if (!formData.bedSize) {
  toast.error("Please enter bed size");
  return;
}
const res = calculateAdhesive({
  area: Number(formData.area),
  tileSize: formData.tileSize,
  surface: formData.surface,
  application: formData.application,
  bedSize: Number(formData.bedSize)
});

  if (res.error) {
    toast.error(res.error);
    return;
  }

  // 👉 store result temporarily
  setPendingResult(res);

  // 👉 store inputs
  setLastInputs(formData);

  // 👉 open popup
  setShowModal(true);
};

const handleUserChange = (e) => {
  const { name, value } = e.target;
  setUserData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmitLead = async () => {

  if (!userData.name) {
    toast.error("Please enter your name");
    return;
  }

 const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

if (!emailRegex.test(userData.email)) {
  toast.error("Please enter a valid email address");
  return;
}

    setLoading(true);

  try {
    // 📩 Email Template (custom for calculator)
 const template = `
<div style="margin:0; padding:40px 0; background:#f4f7fb; font-family:Inter,Arial,sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center">

        <!-- MAIN CARD -->
        <table 
          width="620" 
          cellpadding="0" 
          cellspacing="0" 
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 10px 30px rgba(0,0,0,0.08);
          "
        >

          <!-- TOP HEADER -->
          <tr>
            <td
              style="
               background:linear-gradient(
  135deg,
  #EAF4FF 0%,
  #D8EBFF 45%,
  #BDDFFF 100%
);
                padding:35px 30px;
                text-align:center;
              "
            >

              <!-- LOGO -->
             <div
  style="
    display:inline-block;
    background:rgba(255,255,255,0.04);
    padding:14px 20px;
    border-radius:14px;
    backdrop-filter:blur(4px);
    margin-bottom:18px;
  "
>
  <img 
    src="https://vigoflex.in/files/logo.png"
    alt="VigoFlex Logo"
    style="
      width:160px;
      max-width:100%;
      display:block;
    "
  />
</div>

              <!-- TITLE -->
              <h2
                style="
                  margin:0;
                 color:#1F60A0;
                  font-size:26px;
                  font-weight:700;
                  line-height:1.4;
                "
              >
                New Tile Adhesive Calculator Lead
              </h2>

              <p
                style="
                  margin:10px 0 0;
                  color:#1F60A0;
                  font-size:14px;
                  line-height:1.6;
                "
              >
                A new customer has submitted a tile adhesive calculation inquiry.
              </p>

            </td>
          </tr>

          <!-- BODY -->
          <tr>
            <td style="padding:35px 30px;">

              <!-- USER DETAILS -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="
                  border:1px solid #e6edf5;
                  border-radius:12px;
                  overflow:hidden;
                  margin-bottom:25px;
                "
              >

                <tr>
                  <td
                    style="
                      background:#C8E4FF40;
                      padding:14px 18px;
                      border-left:4px solid #CB2927;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#1F60A0;
                        font-size:18px;
                        font-weight:600;
                      "
                    >
                      User Details
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:20px 18px;">

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Name:</strong> ${userData.name}
                    </p>

                    <p style="margin:0; color:#383838; font-size:15px;">
                      <strong>Email:</strong> ${userData.email}
                    </p>

                  </td>
                </tr>

              </table>

              <!-- CALCULATION DETAILS -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="
                  border:1px solid #e6edf5;
                  border-radius:12px;
                  overflow:hidden;
                  margin-bottom:25px;
                "
              >

                <tr>
                  <td
                    style="
                      background:#C8E4FF40;
                      padding:14px 18px;
                      border-left:4px solid #CB2927;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#1F60A0;
                        font-size:18px;
                        font-weight:600;
                      "
                    >
                      Calculation Details
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:20px 18px;">

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Area:</strong> ${lastInputs.area} Sq Ft
                    </p>

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Tile Size:</strong> ${lastInputs.tileSize}
                    </p>

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Surface:</strong> ${lastInputs.surface}
                    </p>

                    <p style="margin:0; color:#383838; font-size:15px;">
                      <strong>Application:</strong> ${lastInputs.application}
                    </p>

                     <p style="margin:0; color:#383838; font-size:15px;">
                      <strong>Bed Size (mm):</strong> ${lastInputs.bedSize}
                    </p>

                  </td>
                </tr>

              </table>

              <!-- RESULT BOX -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="
                  border-radius:14px;
                  overflow:hidden;
                  background:linear-gradient(135deg,#1F60A0 0%,#0C1A47 100%);
                "
              >

                <tr>
                  <td style="padding:24px;">

                    <h3
                      style="
                        margin:0 0 20px;
                        color:#ffffff;
                        font-size:20px;
                        font-weight:700;
                      "
                    >
                      Calculation Result
                    </h3>

                    <table width="100%" cellpadding="0" cellspacing="0" border="0">

                      <tr>
                        <td
                          style="
                            background:rgba(255,255,255,0.08);
                            padding:14px 16px;
                            border-radius:10px;
                          "
                        >

                          <p style="margin:0 0 8px; color:#dbe8f5; font-size:13px;">
                            TOTAL ADHESIVE REQUIRED
                          </p>

                          <h2 style="margin:0; color:#ffffff; font-size:30px;">
                            ${pendingResult.totalKg} KG
                          </h2>

                        </td>
                      </tr>

                    </table>

                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-top:18px;">

                      <tr>

                        <td
                          width="48%"
                          style="
                            background:rgba(255,255,255,0.08);
                            padding:16px;
                            border-radius:10px;
                          "
                        >

                          <p style="margin:0 0 8px; color:#dbe8f5; font-size:13px;">
                            BAGS REQUIRED
                          </p>

                          <h3 style="margin:0; color:#ffffff; font-size:24px;">
                            ${pendingResult.bags}
                          </h3>

                        </td>

                        <td width="4%"></td>

                        <td
                          width="48%"
                          style="
                            background:rgba(255,255,255,0.08);
                            padding:16px;
                            border-radius:10px;
                          "
                        >

                          <p style="margin:0 0 8px; color:#dbe8f5; font-size:13px;">
                            RECOMMENDED PRODUCT
                          </p>

                          <h3 style="margin:0; color:#ffffff; font-size:20px; line-height:1.4;">
                            ${pendingResult.product}
                          </h3>

                        </td>

                      </tr>

                    </table>

                  </td>
                </tr>

              </table>

            </td>
          </tr>

          <!-- FOOTER -->
          <tr>
            <td
              style="
                padding:22px;
                background:#f7f9fc;
                text-align:center;
                border-top:1px solid #e6edf5;
              "
            >

              <p
                style="
                  margin:0;
                  color:#7d8793;
                  font-size:13px;
                  line-height:1.6;
                "
              >
                © VigoFlex — High Performance Tile Adhesive Solutions
              </p>

            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</div>
`;
    const data = new FormData();
    data.append("title", "VigoFlex Tile Adhesive Calculator Lead");
    data.append("to_email", "info@vigoflex.in"); // 👉 CHANGE THIS
   data.append("cc", "arkayappsseo@gmail.com, sales@arkayapps.com");
    data.append("subject", "VigoFlex New Calculator Lead");
    data.append("template", template);

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    toast.success("Details submitted successfully! 🎉 You can view your Result");

    // 👉 show result AFTER success
    setResult(pendingResult);

    // 👉 close modal
    setShowModal(false);

    // 👉 clear inputs
    setFormData({
      area: "",
      tileSize: "",
      surface: "",
      application: ""
    });

    setUserData({
      name: "",
      email: ""
    });

  } catch (error) {
    console.log(error);
    toast.error("Failed to send details. Try again.");
 } finally {
    setLoading(false); // ✅ stop loading
  }
};

  return (
    <section className="container">
      <ToastContainer position="top-right" autoClose={3000} />
      <motion.div
        className="calc-wrapper"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >

        {/* LEFT SIDE */}
        <motion.div className="calc-left" variants={fade}>
           <div className="calc-form">
          <p className="section-subheading">
            Calculate Your Tile Adhesive Requirement
          </p>

          <h2 className="section-heading">
            Get an instant estimate based on your project size and tile type.
          </h2>

          <p className="section-text" style={{ marginBottom: '30px' }}>
          Quickly estimate the adhesive needed based on your project size and tile type.
          </p>

          {/* INPUT GRID */}
          <div className="input-grid">

  {/* AREA */}
  <motion.div className="input-card" variants={fade}>
    <img src={areaIcon} alt="Area Icon | VigoFlex" className="input-icon" />
    <div className="input-content">
      <label>Area (Sq. Ft)</label>
      <input
        type="number"
        name="area"
        placeholder="Enter Area in Sq. Ft."
        value={formData.area}
        onChange={handleChange}
      />
    </div>
  </motion.div>

  {/* TILE SIZE */}
  <motion.div className="input-card" variants={fade}>
    <img src={tileIcon} alt="Tile Icon | VigoFlex" className="input-icon" />
    <div className="input-content">
      <label>Tile Size</label>
      <select
        name="tileSize"
        value={formData.tileSize}
        onChange={handleChange}
      >
        <option value="">Select Tile Size</option>
        <option value="small">Small (≤ 300x300)</option>
        <option value="medium">Medium (600x600)</option>
        <option value="large">Large (≥ 800x800)</option>
      </select>
    </div>
  </motion.div>

  {/* SURFACE TYPE */}
  <motion.div className="input-card" variants={fade}>
    <img src={surfaceIcon} alt="Surface Icon | VigoFlex" className="input-icon" />
    <div className="input-content">
      <label>Surface Type</label>
      <select
        name="surface"
        value={formData.surface}
        onChange={handleChange}
      >
        <option value="">Select Surface</option>
        <option value="floor">Floor</option>
        <option value="wall">Wall</option>
      </select>
    </div>
  </motion.div>

  {/* APPLICATION TYPE */}
  <motion.div className="input-card" variants={fade}>
    <img src={appIcon} alt="Application Icon | VigoFlex" className="input-icon" />
    <div className="input-content">
      <label>Application Type</label>
      <select
        name="application"
        value={formData.application}
        onChange={handleChange}
      >
        <option value="">Select Application</option>
        <option value="interior">Interior</option>
        <option value="exterior">Exterior</option>
      </select>
    </div>
  </motion.div>

  {/* BED SIZE */}
<motion.div className="input-card" variants={fade}>
  <img src={sizeIcon} alt="Bed Size Icon | VigoFlex" className="input-icon" />
  <div className="input-content">
    <label>Bed Size (mm)</label>
    <input
      type="number"
      name="bedSize"
      placeholder="Enter Bed Size"
      value={formData.bedSize}
      onChange={handleChange}
    />
  </div>
</motion.div>

{/* BUTTON */}
<motion.button
  className="btn btn-outline calc-btn"
  onClick={handleCalculate}
  variants={fade}
  whileHover={{ scale: 1.03 }}
  whileTap={{ scale: 0.96 }}
>
  Calculate Requirement
</motion.button>

</div>
          <motion.div
  key={result?.totalKg}
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.4 }}
></motion.div>
</div>
          <motion.div className="disclaimer-bar" variants={fade}>
            <span>ⓘ</span> Results are indicative. Actual requirement may vary based on site condition.
          </motion.div>
        </motion.div>

        {/* RIGHT SIDE */}
        <motion.div className="calc-right" variants={fade}>
           <div className="calc-result">
          <motion.div
           className="result-card"
  animate={result ? { scale: 1.03, boxShadow: "0 10px 30px rgba(0,0,0,0.15)" } : {}}
  transition={{ duration: 0.4 }}
          >
            <h4 className="result-title">
              ESTIMATED ADHESIVE REQUIREMENT
            </h4>

            <div className="result-main">
              <div>
    <motion.span
       key={result?.totalKg}
  className="result-value"
  initial={{ scale: 0.8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  transition={{ duration: 0.4 }}
    >
      ≈ {result ? `${result.totalKg} KG` : "--"}
    </motion.span>

    {/* 👇 ADD THIS */}
    <p className="result-note">
    {result ? `≈ ${result.bags} Bags (25kg each)` : ""}
    </p>
  </div>

              <div className="bag-icon-circle">
                <img src={bagIcon} alt="Bag Icon | VigoFlex" />
              </div>
            </div>

            <hr className="divider" />

            <div className="result-details">
              <div className="detail-row">
                <span>Surface Area</span>
  <>{lastInputs?.area || "--"} Sq Ft</>
              </div>
              <div className="detail-row">
                 <span>Recommended Product</span>
  <>{result ? result.product : "--"}</>
              </div>

             {result && (
  <p className="result-note section-text">
      Actual consumption may vary based on surface condition and application method
  </p>
)}
            </div>

            {/* HELP BOX */}
            <motion.div
              className="help-box"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.2 }}
            >
              <div className="help-icon-bg">
                <img src={bulbIcon} alt="Bulb Icon | VigoFlex" />
              </div>

              <div className="help-content">
                <h5>Need Help Choosing?</h5>
                <p>
                Our experts are here to help you choose the right product your project.
                </p>
                <a href="/contact-us" className="view-details">
                  Talk to an Expert
                </a>
              </div>
            </motion.div>

          </motion.div>
          </div>
        </motion.div>
        

      </motion.div>
      {showModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h4 className="card-heading">Enter Details to View Result</h4>

      <input
        type="text"
        name="name"
        placeholder="Enter Your Name"
        value={userData.name}
        onChange={handleUserChange}
      />

      <input
        type="email"
        name="email"
        placeholder="Enter Your Email"
        value={userData.email}
        onChange={handleUserChange}
      />

    <button 
  onClick={handleSubmitLead} 
  className="btn btn-primary"
  disabled={loading}
>
  {loading ? "Submitting..." : "Submit & View Result"}
</button>
    </div>
  </div>
)}
    </section>
  );
};

export default CalculatorSection;